import { Button, Grid, Typography } from "@mui/material";

import AlertModal from "components/AlertModal";
import { logout } from "config/authentication";
import { useState } from "react";

function LogoutModal({ open, onClose }) {
  const [loading, setLoading] = useState(false);

  return (
    <AlertModal onClose={onClose} open={open} variant="error">
      <Grid container spacing={2}>
        <Grid item xs={12} mb={2}>
          <Typography textAlign="center" variant="h5" color="text.main">
            آیا می‌خواهید از برنامه خارج شوید؟
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Button color="info" fullWidth onClick={onClose}>
            انصراف
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button
            fullWidth
            color="success"
            disabled={loading}
            onClick={() => {
              setLoading(true);
              logout();
            }}
          >
            خروج
          </Button>
        </Grid>
      </Grid>
    </AlertModal>
  );
}

export default LogoutModal;
